export default {
    count: function(state){
        return state.count +=100;
    },
    hidden(state) {
        // eslint-disable-next-line no-unused-vars
        const temp = state.current 
        if (typeof document.hasFocus !== 'function') {
          return document.hidden
        }
        return !document.hasFocus()
    }
}


// WEBPACK FOOTER //
// ./src/vuex/getters.js